import styled from '@emotion/styled';

export const ProductContractsContainer = styled.div`
  width: 100%;
  height: 100%;
`;
